import { DROPDOWN_TRANSCRIPTION_LOCALE } from "../AppConstants";
import { LogEventNames } from "../backend/interfaces/ITelemetryLogger";
import { HostAppSettingName, HostAppSettings } from "../backend/office-js/HostAppSettings";
import { LogError } from "./ErrorTelemetry";
import { ErrorStringFromException, isNullOrUndefined } from "./utils";

declare const TranscriptionStrings: any;

export const SupportedTranscriptionLocales: Array<string> = new Array(
'ar-BH',
'ar-EG',
'ar-IQ',
'ar-JO',
'ar-KW',
'ar-LB',
'ar-OM',
'ar-QA',
'ar-SA',
'ar-SY',
'ar-AE',
'bg-BG',
'ca-ES',
'zh-HK',
'zh-CN',
'zh-TW',
'hr-HR',
'cs-CZ',
'da-DK',
'nl-NL',
'en-AU',
'en-CA',
'en-HK',
'en-IN',
'en-IE',
'en-NZ',
'en-PH',
'en-SG',
'en-ZA',
'en-GB',
'en-US',
'et-EE',
'fi-FI',
'fr-CA',
'fr-FR',
'de-DE',
'el-GR',
'gu-IN',
'hi-IN',
'hu-HU',
'ga-IE',
'it-IT',
'ja-JP',
'ko-KR',
'lv-LV',
'lt-LT',
'mt-MT',
'mr-IN',
'nb-NO',
'pl-PL',
'pt-BR',
'pt-PT',
'ro-RO',
'ru-RU',
'sk-SK',
'sl-SI',
'es-AR',
'es-BO',
'es-CL',
'es-CO',
'es-CR',
'es-CU',
'es-DO',
'es-EC',
'es-SV',
'es-GT',
'es-HN',
'es-MX',
'es-NI',
'es-PA',
'es-PY',
'es-PE',
'es-PR',
'es-ES',
'es-UY',
'es-US',
'es-VE',
'sv-SE',
'ta-IN',
'te-IN',
'th-TH',
'tr-TR'
);

let defaultTranscriptionLocale: string | null= 'en-US';

export function GetDefaultTranscriptionLocale(): string {
    try {
        const locale: string = HostAppSettings.GetSettingAsString(HostAppSettingName.DefaultTranscriptionLocale);
        try {
          if (!isNullOrUndefined(window) && !isNullOrUndefined(window.localStorage)) {
            defaultTranscriptionLocale = window.localStorage.getItem(DROPDOWN_TRANSCRIPTION_LOCALE);
          }
        } catch(e) {
          LogError(LogEventNames.Warning, "Error getting dropdown transcription locale from local storage" + ErrorStringFromException(e));
          defaultTranscriptionLocale = 'en-US'
        }

        if (locale != null && locale != '' && SupportedTranscriptionLocales.indexOf(locale) != -1) {
            return locale;
        } else {
            return (defaultTranscriptionLocale == null || defaultTranscriptionLocale == '' ? 'en-US' : defaultTranscriptionLocale);
        }
    } catch(e) {
        return (defaultTranscriptionLocale == null || defaultTranscriptionLocale == '' ? 'en-US' : defaultTranscriptionLocale);
    }
}

export function GetLanguageFromLocale(locale: string): string {
    return locale.substr(0,2);
}